import { Col, Row } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import clsx from 'clsx';
import React, { FC } from 'react';
import Left from './components/Left';
import LeftMobile from './components/LeftMobile';
import Right from './components/Right';
import styles from './styles.module.less';

const SymbolPage: FC = () => {
  const { xs } = useBreakpoint();

  return (
    <div className={clsx(styles.root, 'container-fluid')}>
      {xs && <LeftMobile />}
      <Row gutter={[24, 24]}>
        {!xs && (
          <Col xs={6} sm={7} md={6}>
            <Left />
          </Col>
        )}
        <Col xs={24} sm={17} md={18}>
          <Right />
        </Col>
      </Row>
    </div>
  );
};

export default SymbolPage;
